import "firebase/auth";
import {getAuth, signOut as action} from "firebase/auth";
import {firebaseApp} from "../model/firebaseApp";


export const signOut = async (id, password) => {
    const auth = getAuth(firebaseApp);
    return action(auth)
}




